import { FC } from 'react';
import { Button } from '@mui/material';
import { LinkFlow } from '../../services/sendLinkManager';
import { ESendLinkModal } from '../../constants';

type SendEmailLinkProps = { action: LinkFlow; onSendEmail: () => void };

export const SendEmailLink: FC<SendEmailLinkProps> = ({
  action,
  onSendEmail,
}) => {
  const actionText = action === LinkFlow.Apply ? 'Apply' : 'Checkout';
  return (
    <Button onClick={onSendEmail} disableRipple variant="link">
      {ESendLinkModal.Send} {actionText} {ESendLinkModal.LinkViaEmail}
    </Button>
  );
};
